import { useRevealOnScroll } from '../../hooks/useRevealOnScroll';
import { cn } from '../../lib/utils';

const ITEMS = [
  {
    title: 'Обсмажуємо двічі на тиждень',
    text: 'Вівторок і пʼятниця. Кава їде до вас наступного дня після обсмажки, а не після місяця на складі.',
  },
  {
    title: 'Партія до 8 кг',
    text: 'Малий барабан дає контроль над профілем. Кожна партія має свій номер і протокол обсмажки.',
  },
  {
    title: 'Помел під ваш спосіб',
    text: 'Меремо безпосередньо перед відправкою — під турку, еспресо чи фільтр. Або лишаємо в зернах.',
  },
  {
    title: 'Дата обсмажки на кожній пачці',
    text: 'Ви завжди бачите, коли саме обсмажена ваша кава — на сайті й на самій упаковці.',
  },
];

function Row({ index, title, text }: { index: number; title: string; text: string }) {
  const { ref, revealed } = useRevealOnScroll<HTMLDivElement>();
  return (
    <div
      ref={ref}
      className={cn(
        'grid grid-cols-[minmax(0,1fr)] gap-[10px] border-t border-line py-[26px] transition-all duration-700',
        revealed ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0',
      )}
    >
      <div className="flex flex-wrap items-baseline gap-6">
        <span className="font-mono text-[11px] tracking-[0.16em] text-accent">
          {String(index + 1).padStart(2, '0')}
        </span>
        <h3 className="m-0 min-w-[min(100%,280px)] flex-1 text-[clamp(24px,3.4vw,42px)] font-bold tracking-[-0.035em]">
          {title}
        </h3>
        <p className="max-w-[46ch] flex-1 text-[15px] leading-[1.6] text-muted">{text}</p>
      </div>
    </div>
  );
}

export function Advantages() {
  return (
    <section className="section-pad">
      <p className="mb-10 font-mono text-[11px] uppercase tracking-[0.16em] text-accent">
        ЧОМУ САМЕ НАШЕ ОБСМАЖУВАННЯ
      </p>
      {ITEMS.map((item, index) => (
        <Row key={item.title} index={index} title={item.title} text={item.text} />
      ))}
    </section>
  );
}
